

export class RouteGroupActiveOutputData implements IRouteGroupActiveOutputData {
    /** The auto-generated id of the alert group master */
    alert_group_id!: number;
    /** The route group name with 255 character limit */
    route_group_name!: string;

    constructor(data?: IRouteGroupActiveOutputData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.alert_group_id = _data["alert_group_id"];
            this.route_group_name = _data["route_group_name"];
        }
    }

    static fromJS(data: any): RouteGroupActiveOutputData {
        data = typeof data === 'object' ? data : {};
        let result = new RouteGroupActiveOutputData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["alert_group_id"] = this.alert_group_id;
        data["route_group_name"] = this.route_group_name;
        return data; 
    }
}

export interface IRouteGroupActiveOutputData {
    /** The auto-generated id of the alert group master */
    alert_group_id: number;
    /** The route group name with 255 character limit */
    route_group_name: string;
}

